<template>
<Top-Header />
<Brand-Header />
<mobile-nav v-if="$route.name != 'Callback'" />
</template>

<script setup>
import TopHeader from "./topHeader.vue";
import BrandHeader from "./brand.vue";
import MobileNav from "@/components/section/header/mobileNav.vue";

import { onMounted } from 'vue';
onMounted(() => {
  if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
  }
})
window.scrollTo(0,0);
</script>